import React, { FC } from 'react'
import { Modal } from '@wmgtech/legato'

import { FeedbackForm } from 'modulesCommon/FeedbackForm'
import { FeedBackModalProps } from './FeedBackModal.props'

const FeedBackModal: FC<FeedBackModalProps> = ({ isOpen, onClose, artistName, projectName }) => (
  <Modal isOpen={isOpen} onClose={onClose} shouldCloseOnOverlayClick={false} title="Leave Feedback">
    <p>
      Please let us know if you have a suggestion for how we can improve the Global Hub or have an idea for a new
      feature. We are an ever-evolving project that gets better thanks to input from our users. So let us know what you
      think!
    </p>
    <FeedbackForm onClose={onClose} artistName={artistName} projectName={projectName} />
  </Modal>
)

export default FeedBackModal
